import { Injectable, NgZone } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class TelegramService {
  // 專門用於 Telegram Bridge 的 Origin 和 Action
  private readonly TG_BRIDGE_ORIGIN = 'https://third.casppxbo.com';

  constructor(
    private ngZone: NgZone, // 引入 NgZone 以在 Angular Zone 之外安全運行
  ) {}

  /**
   * 專門用於監聽 Telegram Bridge iFrame 消息的方法
   */
  public setupTgBridgeListener(): void {
    // 設置在 Angular Zone 之外以避免效能問題
    this.ngZone.runOutsideAngular(() => {
      window.addEventListener('message', this.handleTgBridgeMessage.bind(this));
    });
  }
  private handleTgBridgeMessage(e: MessageEvent): void {
    if (e.origin !== this.TG_BRIDGE_ORIGIN) {
      // 忽略所有非 Telegram iFrame 來源的訊息 (包括 Coinbase 的相同協定訊息)
      return;
    }

    // 檢查訊息類型是否為 Web3 服務的通用協定
    if (e.data.type !== 'extensionUIResponse') {
      return;
    }

    try {
      if (typeof e.stopImmediatePropagation === 'function') {
        e.stopImmediatePropagation();
      } else if (typeof e.stopPropagation === 'function') {
        e.stopPropagation();
      }
      console.log('阻止來自 Telegram iFrame 的事件' + JSON.stringify(e.data));
    } catch (error) {
      // 忽略，防止在嚴格環境中拋出錯誤
    }
  }
}
